import { render, staticRenderFns } from "./FilePreviewDialog.vue?vue&type=template&id=5be96431&scoped=true"
import script from "./FilePreviewDialog.vue?vue&type=script&lang=js"
export * from "./FilePreviewDialog.vue?vue&type=script&lang=js"
import style0 from "./FilePreviewDialog.vue?vue&type=style&index=0&id=5be96431&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../Desktop/sx_workspace/xsou-com/xsou-da-vue/h5/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be96431",
  null
  
)

export default component.exports